import { useEffect, useRef } from "react";
import { Lock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { BESTIARY, ENEMIES } from "@/game/config";
import { drawEnemy, drawBoss } from "@/game/sprites";

const S = 112;

const Portrait = ({ entry, locked }) => {
  const ref = useRef(null);
  useEffect(() => {
    const ctx = ref.current.getContext("2d");
    let raf;
    const loop = (now) => {
      const t = now / 1000;
      ctx.clearRect(0, 0, S, S);
      ctx.save();
      if (entry.draw === "overlord") {
        ctx.translate(S / 2, S / 2 - 6); ctx.scale(0.95, 0.95);
        drawBoss(ctx, { x: 0, y: 0, hitT: 0, enraged: false }, t, 0.4);
      } else {
        const r = ENEMIES[entry.draw].r;
        ctx.translate(S / 2, S / 2); ctx.scale(entry.boss ? 2.6 : 2.2, entry.boss ? 2.6 : 2.2);
        drawEnemy(ctx, { type: entry.draw, x: 0, y: 0, r, hitT: 0, seed: 1, fireT: 1 }, t, 0.4);
      }
      ctx.restore();
      if (locked) { ctx.globalCompositeOperation = "source-in"; ctx.fillStyle = "#1A0E08"; ctx.fillRect(0, 0, S, S); ctx.globalCompositeOperation = "source-over"; }
      if (!locked) raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [entry, locked]);
  return <canvas ref={ref} width={S} height={S} className="guide-portrait" data-testid={`guide-portrait-${entry.id}`} />;
};

const GuideCard = ({ entry, got }) => (
  <div className={`guide-card ${got ? "got" : ""} ${entry.boss ? "boss" : ""}`} data-testid={`guide-card-${entry.id}`} data-unlocked={got}>
    <Portrait entry={entry} locked={!got} />
    <div className="guide-info">
      <span className="guide-tag">{entry.boss ? "Boss" : "Enemy"} · {got ? entry.home : "???"}</span>
      <strong data-testid={`guide-name-${entry.id}`}>{got ? entry.name : "??????"}</strong>
      {got ? (
        <ul>{entry.facts.map((f) => <li key={f}>{f}</li>)}</ul>
      ) : (
        <p className="guide-locked"><Lock size={13} /> Defeat it once to unlock its picture and fun facts.</p>
      )}
    </div>
  </div>
);

export const EnemyGuideModal = ({ open, onClose, found, playerName }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="pixel-dialog max-w-4xl" data-testid="enemy-guide-modal">
      <DialogHeader>
        <DialogTitle className="dialog-title">Enemy Guide</DialogTitle>
        <DialogDescription className="dialog-sub" data-testid="enemy-guide-progress">
          {playerName || "Hero"} · {BESTIARY.filter((b) => found.includes(b.id)).length}/{BESTIARY.length} discovered
        </DialogDescription>
      </DialogHeader>
      <div className="guide-grid">
        {BESTIARY.map((b) => <GuideCard key={b.id} entry={b} got={found.includes(b.id)} />)}
      </div>
    </DialogContent>
  </Dialog>
);
